import React from 'react';
import { IOldIconProps } from './type';

const UserOutline: React.FC<IOldIconProps> = ({
  width = 24,
  height = 25,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8126 4.0835C9.0167 4.0835 6.75014 6.35005 6.75014 9.146C6.75014 10.4703 7.25865 11.6759 8.09106 12.5781C6.04543 13.9887 4.49684 16.5047 3.76603 19.5132C3.6927 19.8151 3.87797 20.1193 4.17985 20.1926C4.48174 20.2659 4.78591 20.0807 4.85923 19.7788C5.57021 16.8518 7.0798 14.5487 8.93132 13.3706C8.9467 13.3608 8.96143 13.3504 8.97552 13.3394C9.7848 13.888 10.7613 14.2085 11.8126 14.2085C12.864 14.2085 13.8405 13.888 14.6497 13.3394C14.6638 13.3504 14.6786 13.3608 14.6939 13.3706C16.5455 14.5487 18.055 16.8518 18.766 19.7788C18.8394 20.0807 19.1435 20.2659 19.4454 20.1926C19.7473 20.1193 19.9326 19.8151 19.8592 19.5132C19.1284 16.5047 17.5798 13.9887 15.5342 12.5781C16.3666 11.6759 16.8751 10.4703 16.8751 9.146C16.8751 6.35005 14.6086 4.0835 11.8126 4.0835ZM7.87514 9.146C7.87514 6.97137 9.63802 5.2085 11.8126 5.2085C13.9873 5.2085 15.7501 6.97137 15.7501 9.146C15.7501 11.3206 13.9873 13.0835 11.8126 13.0835C9.63802 13.0835 7.87514 11.3206 7.87514 9.146Z"
      fill="black"
    />
  </svg>
);

export default UserOutline;
